var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "seal-manage" },
    [
      _c(
        "div",
        {
          staticClass: "seal-wrap",
          style: _vm.isInDingTalk ? "height: 72vh" : ""
        },
        [
          _c("div", { staticClass: "box-right" }, [
            _c("div", { staticStyle: { background: "#ffffff" } }, [
              _c(
                "h1",
                {
                  staticClass: "com-title com-ht",
                  staticStyle: { "padding-top": "20px" }
                },
                [
                  _c("span", [
                    _c("i"),
                    _vm._v("用章的审批流程-" + _vm._s(_vm.oneSealInfo.signName))
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        plain: "",
                        size: "small",
                        disabled: !_vm.perms.includes(103)
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("editApproveFn", _vm.oneSealInfo)
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.oneSealInfo.flowId || _vm.oneSealInfo.dingTalkFlow
                            ? "修改"
                            : "添加用印审批流程"
                        )
                      )
                    ]
                  )
                ],
                1
              ),
              _vm.flowInfo.length
                ? _c("div", { staticClass: "liucheng-box" }, [
                    _c("p", { staticClass: "text" }, [
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.currentProcess && _vm.currentProcess.flowName,
                            expression:
                              "currentProcess && currentProcess.flowName"
                          }
                        ],
                        staticClass: "dian"
                      }),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentProcess
                              ? _vm.currentProcess.flowName
                              : ""
                          )
                        )
                      ]),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.currentProcess &&
                                _vm.currentProcess.useStatus,
                              expression:
                                "currentProcess && currentProcess.useStatus"
                            }
                          ]
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.currentProcess &&
                                _vm.currentProcess.useStatus === 1
                                ? "（已停用）"
                                : ""
                            )
                          )
                        ]
                      )
                    ]),
                    _c(
                      "div",
                      [
                        _c("approval-process", {
                          attrs: {
                            flowInfo: _vm.flowInfo,
                            orderFlag:
                              _vm.oneSealInfo.flowDetail && !_vm.isInDingTalk
                                ? _vm.oneSealInfo.flowDetail.orderFlag
                                : _vm.oneSealInfo.dingTalkFlow
                                ? _vm.oneSealInfo.dingTalkFlow.flowType
                                : ""
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        padding: "40px 0 10px 0"
                      }
                    },
                    [
                      _c("p", [_vm._v("若未添加审批流程，用章时无需审批，")]),
                      _c("p", [_vm._v("可直接使用该印章进行文件签署")])
                    ]
                  )
            ]),
            _c("div", {
              staticStyle: {
                height: "15px",
                width: "100%",
                background: "#f5f5f5"
              }
            }),
            _c(
              "div",
              { staticStyle: { background: "#ffffff" } },
              [
                _c("h1", { staticClass: "com-title com-ht" }, [
                  _c("span", [
                    _c("i"),
                    _vm._v(
                      "印章授权-" + _vm._s(_vm.oneSealInfo.signName) + " "
                    ),
                    _c("span", [_vm._v("  /仅对我管理的部门成员印章授权")])
                  ]),
                  _c(
                    "span",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function($event) {
                              return _vm.chooseCancelAuth()
                            }
                          }
                        },
                        [_vm._v("取消授权")]
                      ),
                      _c(
                        "el-tooltip",
                        { attrs: { placement: "bottom", effect: "light" } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _vm._v(
                                "\n                将印章授权给企业成员，"
                              ),
                              _c("br"),
                              _vm._v("该成员即可代表企业使"),
                              _c("br"),
                              _vm._v("用印章进行文件签署。\n              ")
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                plain: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.initMemberForm()
                                }
                              }
                            },
                            [_vm._v("授权给成员")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c(
                  "el-table",
                  {
                    staticStyle: {
                      border: "1px solid #eeeeee",
                      "border-bottom": "0",
                      "margin-top": "30px"
                    },
                    attrs: {
                      data: _vm.sealUsers,
                      "tooltip-effect": "dark",
                      "header-cell-style": {
                        background: "#f9f9f9",
                        color: "#333333",
                        fontWeight: "600"
                      }
                    },
                    on: { "selection-change": _vm.handleSelectionChange0 }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        width: "55",
                        selectable: function(row, index) {
                          return row.canBeAuthorized != 1 ? false : true
                        }
                      }
                    }),
                    _c("el-table-column", {
                      attrs: { label: "名称", "show-overflow-tooltip": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.userName) +
                                  "\n              "
                              ),
                              scope.row.targetId != ""
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s("(" + scope.row.targetId + ")")
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "部门",
                        prop: "groupNames",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return _c("div", {}, [
                              _c(
                                "span",
                                {
                                  staticClass: "color-danger",
                                  class: {
                                    "dis-sty":
                                      !_vm.btnEven ||
                                      (_vm.btnEven &&
                                        scope.row.canBeAuthorized !== 1)
                                  },
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.chooseCancelAuth(
                                        scope.row,
                                        true
                                      )
                                    }
                                  }
                                },
                                [_vm._v("取消授权")]
                              )
                            ])
                          }
                        }
                      ])
                    }),
                    _c("no-data", {
                      attrs: { slot: "empty", text: "暂无数据" },
                      slot: "empty"
                    })
                  ],
                  1
                ),
                _vm.pageTotalLt > 0
                  ? _c(
                      "el-row",
                      { staticClass: "pageation" },
                      [
                        _c(
                          "el-col",
                          {
                            staticClass: "page-flex-end",
                            staticStyle: { padding: "30px 0" },
                            attrs: { span: 24 }
                          },
                          [
                            _c("el-pagination", {
                              attrs: {
                                "current-page": _vm.itemPageLt,
                                "page-sizes": [10, 20, 50, 100],
                                "page-size": _vm.pageSizeLt,
                                layout: "sizes, prev, pager, next, total",
                                total: _vm.pageTotalLt
                              },
                              on: {
                                "size-change": _vm.handleSizeChangeLt,
                                "current-change": _vm.handleCurrentChangeLt
                              }
                            }),
                            _c("el-go", {
                              attrs: {
                                "page-size": _vm.pageSizeLt,
                                total: _vm.pageTotalLt
                              },
                              on: {
                                "current-change": _vm.handleCurrentChangeLt
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "关联审批",
            visible: _vm.authDialogVisible,
            width: "45%",
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              _vm.authDialogVisible = $event
            }
          }
        },
        [
          _c(
            "p",
            {
              staticStyle: {
                "font-size": "14px",
                "font-weight": "400",
                "line-height": "24px",
                color: "#290202",
                "margin-bottom": "10px"
              }
            },
            [
              _c("i", { staticClass: "warn-img el-icon-warning" }),
              _vm._v(
                "\n      将印章与用印审批流程关联，使用印章签署文件时需先进行审批，"
              ),
              _c(
                "span",
                { staticClass: "addsign", on: { click: _vm.turnToSP } },
                [_vm._v("新增用印审批流程>>")]
              )
            ]
          ),
          _c(
            "ul",
            { staticClass: "liuChengUl" },
            _vm._l(_vm.processList, function(item, index) {
              return _c(
                "li",
                {
                  key: index,
                  style:
                    _vm.choosedProcess &&
                    _vm.choosedProcess.flowId == item.flowId
                      ? "background:#f1f1f1"
                      : "",
                  on: {
                    click: function($event) {
                      _vm.choosedProcess = item
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../../static/images/icon/icon-liucheng.jpg"),
                      alt: ""
                    }
                  }),
                  _vm._v(_vm._s(item.flowName) + "\n      ")
                ]
              )
            }),
            0
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.chooseProcess()
                    }
                  }
                },
                [_vm._v("确认")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.authDialogVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "印章授权",
            visible: _vm.ChooseDialogVisible,
            top: "5vh",
            width: "60%",
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              _vm.ChooseDialogVisible = $event
            }
          }
        },
        [
          _c(
            "p",
            {
              staticStyle: {
                "font-size": "14px",
                "font-weight": "400",
                "line-height": "24px",
                color: "#290202",
                "margin-bottom": "20px"
              }
            },
            [
              _c("i", { staticClass: "warn-img el-icon-warning" }),
              _vm._v(
                "\n      将印章授权给选中成员，被选中的成员则可以使用印章签署文件\n    "
              )
            ]
          ),
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              staticStyle: { margin: "-10px 0 10px 0", "text-align": "right" },
              attrs: { size: "small", inline: true, model: _vm.memberForm }
            },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "邮箱/手机号" },
                    model: {
                      value: _vm.memberForm.targetId,
                      callback: function($$v) {
                        _vm.$set(_vm.memberForm, "targetId", $$v)
                      },
                      expression: "memberForm.targetId"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "签署方名称" },
                    model: {
                      value: _vm.memberForm.userName,
                      callback: function($$v) {
                        _vm.$set(_vm.memberForm, "userName", $$v)
                      },
                      expression: "memberForm.userName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticStyle: { "margin-right": "0px" } },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.getCmSealUsers(0)
                        }
                      }
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.reset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: {
                border: "1px solid #eeeeee",
                "border-bottom": "0",
                "margin-top": "-15px"
              },
              attrs: {
                data: _vm.unSealUsers,
                "tooltip-effect": "dark",
                "header-cell-style": {
                  background: "#f9f9f9",
                  color: "#333333",
                  fontWeight: "600"
                }
              },
              on: { "selection-change": _vm.handleSelectionChange }
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "邮箱/手机号",
                  "show-overflow-tooltip": "",
                  prop: "targetId"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "名称",
                  "show-overflow-tooltip": "",
                  prop: "userName"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "部门",
                  prop: "groupNames",
                  "show-overflow-tooltip": ""
                }
              })
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.ChooseMember(1)
                    }
                  }
                },
                [_vm._v("确认")]
              )
            ],
            1
          ),
          _vm.pageTotal > 0
            ? _c(
                "el-row",
                { staticClass: "pageation" },
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "page-flex-end",
                      staticStyle: { padding: "30px 0" },
                      attrs: { span: 24 }
                    },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.itemPage,
                          "page-sizes": [10, 20, 50, 100],
                          "page-size": _vm.pageSize,
                          layout: "sizes, prev, pager, next, total",
                          total: _vm.pageTotal
                        },
                        on: {
                          "size-change": _vm.handleSizeChange,
                          "current-change": _vm.handleCurrentChange
                        }
                      }),
                      _c("el-go", {
                        attrs: {
                          "page-size": _vm.pageSize,
                          total: _vm.pageTotal
                        },
                        on: { "current-change": _vm.handleCurrentChange }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "取消授权",
            visible: _vm.cancelAuthDialogVisible,
            width: "30%",
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              _vm.cancelAuthDialogVisible = $event
            }
          }
        },
        [
          _c("span", [_vm._v("是否取消授权？")]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.cancelAuthDialogVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.cancelAuth()
                    }
                  }
                },
                [_vm._v("确认")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "取消审批流程",
            visible: _vm.cancelAuthProcessDialogVisible,
            width: "30%",
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              _vm.cancelAuthProcessDialogVisible = $event
            }
          }
        },
        [
          _c("span", [_vm._v("是否取消盖章审核流程？")]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.cancelProcess()
                    }
                  }
                },
                [_vm._v("确认")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.cancelAuthProcessDialogVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择印章（可多选）",
            visible: _vm.showEditSeal,
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              _vm.showEditSeal = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "checkbox" },
            _vm._l(_vm.chapterList, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "temone",
                  style: _vm.chapterChecked.includes(item.signId)
                    ? "border: 1px solid #d9001b;"
                    : "",
                  on: {
                    click: function($event) {
                      return _vm.checkChange(item.signId)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "t-box" }, [
                    _c("img", {
                      staticClass: "y-img",
                      attrs: { src: item.signUrl, title: item.signName }
                    })
                  ]),
                  _c(
                    "p",
                    {
                      style: _vm.chapterChecked.includes(item.signId)
                        ? "background-color:#d9001b;color:#fff"
                        : "",
                      attrs: {
                        title: item.signName + "(ID:" + item.signId + ")"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(item.signName + "(ID:" + item.signId + ")") +
                          "\n        "
                      )
                    ]
                  )
                ]
              )
            }),
            0
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer cha-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("span", [
                _vm._v("已选择"),
                _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(_vm._s(_vm.chapterChecked.length))
                ]),
                _vm._v("个")
              ]),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "mini",
                        type: "primary",
                        loading: _vm.btnLoading
                      },
                      on: { click: _vm.chooseChapter }
                    },
                    [_vm._v("确认")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { size: "mini" }, on: { click: _vm.showChange } },
                    [_vm._v("取消")]
                  )
                ],
                1
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4053b5bd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4053b5bd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/console/seal/grant.vue
// module id = qKmA
// module chunks = 7 30